import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSignOutAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { RootState, AppDispatch } from '../../../store';
import { logoutUser } from '../../../store/authSlice';
import { setCurrentEvent } from '../../../store/eventsSlice';
import { SidebarDropdown } from '../SidebarDropdown';
import { UserMenuProps } from './UserMenu.types';

/**
 * Sidebar user dropdown, shared by the Dashboard and Event layouts. Shows the current
 * user's email and role, an optional "Select Event" action, and "Sign Out". Owns the
 * logout flow (previously duplicated identically in both layouts).
 */
export default function UserMenu({ onSelectEvent }: UserMenuProps): React.ReactElement {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { user } = useSelector((state: RootState) => state.auth);

    const handleLogout = async () => {
        await dispatch(logoutUser());
        dispatch(setCurrentEvent(null));
        navigate('/login');
    };

    return (
        <SidebarDropdown
            icon={faUser}
            label={user?.username || 'User'}
            toggleId="user-dropdown"
        >
            <Dropdown.Header>
                <small className="text-muted">{user?.email || ''}</small>
                <br />
                <small className="text-muted text-capitalize">
                    Role: {user?.role || 'Unknown'}
                </small>
            </Dropdown.Header>
            <Dropdown.Divider />
            {onSelectEvent && (
                <Dropdown.Item onClick={onSelectEvent}>
                    <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                    Select Event
                </Dropdown.Item>
            )}
            <Dropdown.Item onClick={handleLogout}>
                <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
                Sign Out
            </Dropdown.Item>
        </SidebarDropdown>
    );
}
